// Oturum gerektiren route'lar için sarmalayıcı. Giriş yapılmamışsa /login'e
// yönlendirir ve gelinen konumu state'te taşır (login sonrası geri dönmek için).

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
